import api from "../../helpers/api"

export const getArtisanTags = (body) => api.post('artisan-tag/search-artisan-tags' , {...body})

export const createArtisanTag = (formData) => api.post('artisan-tag',{...formData})

export const updateArtisanTag = (id, formData) => api.put(`artisan-tag/${id}` , {...formData})